import ColorfulCollapse from './colorful-collapse';
export default ColorfulCollapse;
